var c = Object.defineProperty;
var a = (o, e, r) => e in o ? c(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r;
var n = (o, e, r) => a(o, typeof e != "symbol" ? e + "" : e, r);
const t = ["trace", "debug", "log", "info", "warn", "error"];
function f() {
  return typeof window > "u" ? !1 : window.sessionStorage.getItem("DSY_SWYM_DEBUG") || !1;
}
function u() {
  return typeof window > "u" ? !1 : window.localStorage.getItem("logger-debug") || !1;
}
function h() {
  return typeof window > "u" ? !1 : new URL(window.location.href).searchParams.has("debug");
}
function i(o) {
  return typeof o == "string" ? t.includes(o) ? o : o !== "false" : o;
}
function s(o) {
  return typeof o == "boolean" ? o ? 0 : t.length : t.indexOf(o);
}
class L {
  constructor() {
    n(this, "logLevelIndex", s(!1));
    n(this, "_log", (e, ...r) => {
      const g = this._getScope(e), d = this.emojis[e], l = this.styles[e];
      this._shouldLog(e) && console[e](`${d} %c[${g}]`, l, ...r);
    });
    n(this, "emojis", {
      trace: "🧵",
      debug: "🛠️",
      log: "📋",
      info: "📢",
      warn: "🚧",
      error: "🔥"
    });
    n(this, "styles", {
      trace: "",
      debug: "color: white; background: #3d3d3d;",
      log: "color: black; background: #D5E8F2;",
      info: "color: black; background: #EDF6EB;",
      warn: "background: transparent;",
      error: "background: transparent;"
    });
    n(this, "_getScope", (e) => `LOGGER ${e.toUpperCase().padEnd(5, " ")}`);
    /** @see Console.log */
    n(this, "log", this._log.bind(this, "log"));
    /** @see Console.info */
    n(this, "info", this._log.bind(this, "info"));
    /** @see Console.warn */
    n(this, "warn", this._log.bind(this, "warn"));
    /** @see Console.debug */
    n(this, "debug", this._log.bind(this, "debug"));
    /** @see Console.error */
    n(this, "error", this._log.bind(this, "error"));
    /** @see Console.trace */
    n(this, "trace", this._log.bind(this, "trace"));
    const e = i(h()) || i(u()) || i(f());
    this.logLevelIndex = s(e);
  }
  _shouldLog(e) {
    return t.indexOf(e) >= this.logLevelIndex;
  }
}
const w = new L();
export {
  L as Logger,
  w as logger
};
